import { render, staticRenderFns } from "./CsTextarea.vue?vue&type=template&id=f09f9b32&"
import script from "./CsTextarea.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsTextarea.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports